export default __webpack_public_path__ + "static/media/stMATIC.b02e5840.png";